<template>
  <div
    class="bottom-button"
    :class="{ checkapp: platform === 'checkapp', disabled: disabled }"
    @click="clicked"
  >
    <span :class="{ disabled: disabled }">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: 'BottomButton',
  props: {
    platform: {
      type: String,
      default: 'zz'
    },
    text: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clicked() {
      if (this.disabled) return
      this.$emit('click')
    }
  }
}
</script>

<style lang="less" scoped>
  @import './BottomButton.less';
</style>
